import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import chevronPrimaryRoundedIcon from '@/assets/icons/chevron-rounded-primary-down.svg';

export interface GeneralInfoAccordionItem {
  label: string;
  value: string;
  description?: string;
}

interface GeneralInfoAccordionProps {
  items: GeneralInfoAccordionItem[];
  className?: string;
}

const GeneralInfoAccordion: React.FC<GeneralInfoAccordionProps> = ({ items, className = '' }) => {
  return (
    <Accordion defaultValue="item-1" type="single" collapsible className={className}>
      <AccordionItem value="item-1" className="bg-lightPurple rounded-[16px] overflow-hidden">
        <AccordionTrigger
          icon={<img src={chevronPrimaryRoundedIcon} alt="chevron icon" />}
          className="border-b border-lightPurple-200 py-0 min-h-[52px] px-4"
        >
          <div>
            <p className="text-primary font-bold text-base">General Information</p>
          </div>
        </AccordionTrigger>
        <AccordionContent className="p-4 space-y-[1.1rem]">
          {items.map((item, index) => (
            <div key={index}>
              <span className="text-[11px] text-lightPurple-300 font-medium">{item.label}</span>
              <p className="text-sm font-medium leading-[17px]">
                {item.value}
                {item.description && (
                  <span className="text-secondary text-xs font-medium ml-1">({item.description})</span>
                )}
              </p>
            </div>
          ))}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default GeneralInfoAccordion;
